<template>
  <div class="view-recipes page">
    <RecipeGrid v-if="recipes" :recipes="recipes" />
  </div>
</template>
<script>
import RecipeGrid from "@/components/listing/RecipeGrid.vue";

export default {
  name: "Recipes",
  components: {
    RecipeGrid
  },
  data() {
    return {
      tet: "tess",
      recipes: false,
      categories: false
    };
  },
  mounted() {
    this.fetchRecipe();
    this.fetchCategories();
  },
  methods: {
    async fetchRecipe() {
      this.recipes = await this.getApi("allrecipes");
    },
    async fetchCategories() {
      this.categories = await this.getApi("featured-categories");
    }
  }
};
</script>
<style lang="scss">
.view-recipes {
  padding-top: 30px;
  padding-bottom: 40px;
}
</style>
